import SubsFeeActions from "@frameworks/web/redux/actions/Reports/SubscriptionFee";
export default () => {
    return {
        subscription: new SubsFeeActions(),
    };
};
